window.Mobile = (function () {
    var scrollSave = 0;

    function toggleCartVisibility() {
        var htmlTag = $('html');

        if (htmlTag.hasClass('m-cart-is-visible') && htmlTag.hasClass('m-overflow-hidden')) {
            $('.cart').removeClass('visible');
            $('.cart-show-button').removeClass('visible');
            htmlTag.removeClass('m-cart-is-visible');
            htmlTag.removeClass('m-overflow-hidden');
            $(window).scrollTop(scrollSave);//сохранить знач.скролла
        } else {
            scrollSave = $(window).scrollTop();
            $('.cart').addClass('visible');
            $('.cart-show-button').addClass('visible');
            htmlTag.addClass('m-cart-is-visible');
            htmlTag.addClass('m-overflow-hidden');
        }

        $('.cart').removeClass('collapsed');
    }

    function toggleMenuVisibility() {
        var htmlTag = $('html');
        var tagClass = htmlTag.hasClass('m-overflow-hidden');

        if (!tagClass) {
            scrollSave = $(window).scrollTop();
            htmlTag.addClass('m-overflow-hidden');
            $('#app-header').addClass('m-expanded');
        } else {
            htmlTag.removeClass('m-overflow-hidden');
            $('#app-header').removeClass('m-expanded');
            $(window).scrollTop(scrollSave);//сохранить знач.скролла
        }
    }

    function syncCartCoefsCounter(stringVal, counterContainer) {
        stringVal = stringVal.trim();
        var val = (stringVal.length > 0) ? parseInt(stringVal) : 0;
        counterContainer.html(val);

        if (val === 0) {
            counterContainer.hide();
        } else {
            counterContainer.show();
        }
    }

    var init = function () {
        $('html').addClass('m-mobile');

        if (!globalAppSettings.isMobileDeviceInDesktopMode) {
            // кнопка панели навигации (гамбургер)
            var showMenu = $('#app-header');
            showMenu.prepend('<div class="hamburger-menu-button" data-mtm-trigger="d-i05-e2" onclick="Mobile.toggleMenuVisibility()"><span></span><span></span><span></span></div>');

            if (!$('#layout-right-column').hasClass('m-hidden') && $('[js-node="betting-cart"]').length > 0) {
                // кнопка корзины
                var showCartButton = $('<div/>', { 'class': 'cart-show-button', 'data-mtm-trigger': 'd-i21-e7-old' });
                // счетчик добавленных кэфов в корзине
                var cartCoefsCounter = $('<div/>', { 'class': 'cart-show-button__coefs-counter' });

                showCartButton.append(Utils.svgHtml('shopping-cart', 'cart-show-button__icon') + Utils.svgHtml('arrow', 'cart-hide-button__icon'));


                showCartButton.on('click', function () {

                    toggleCartVisibility(this);

                });

                var originalCounterBlock = $('[js-node="betting-cart__items-count"]');

                if (originalCounterBlock.length) {
                    syncCartCoefsCounter(originalCounterBlock.html(), cartCoefsCounter);
                }

                showCartButton.append(cartCoefsCounter);

                $(document).on('DOMSubtreeModified', '[js-node="betting-cart__items-count"]', function () {
                    syncCartCoefsCounter($(this).html(), cartCoefsCounter);
                });

                $('body').append(showCartButton);
            }

            $(document).on('click', '#messages__navigation-block', function () {
                window.location.pathname = '/account/messages';
            });
        };
    };



    return {
        init: init,
        toggleMenuVisibility: toggleMenuVisibility,
        toggleCartVisibility: toggleCartVisibility
    };
}());